{
  "markread": "označiť ako prečítané",
  "filter": "Zobrazovať",
  "newest": "najnovšie",
  "unread": "neprečítané",
  "starred": "označené",
  "tags": "Tagy",
  "alltags": "všetky tagy",
  "timestamp": "{0,date} {0,time}",
  "hours": "pred {0,plural,one {1 hodinou},other {# hodinami}}",
  "minutes": "pred {0,plural,one {1 minútou},other {# minútami}}",
  "seconds": "pred {0,plural,one {chvíľou},other {# sekundami}}",
  "star": "označiť",
  "unstar": "odznačiť",
  "mark": "označiť ako prečítané",
  "unmark": "označiť ako neprčítané",
  "load_img": "nahrať obrázky",
  "open_window": "otvoriť",
  "next": "ďalšie",
  "searchbutton": "vyhľadať",
  "searchremove": "skryť vyhľadávanie",
  "refreshbutton": "obnoviť zdroje",
  "settingsbutton": "nastavenia",
  "logoutbutton": "odhlásiť sa",
  "loginbutton": "prihlásiť sa",
  "sources": "Zdroje",
  "source_add": "pridať zdroj",
  "source_opml": "alebo nahrať opml súbor",
  "source_export": "export zdrojov",
  "source_edit": "upraviť",
  "source_filter": "Filter",
  "source_delete": "zmazať",
  "source_warn": "Naozaj chcete tento zdroj zmazať?",
  "source_new": "nový neuložený zdroj",
  "source_title": "Názov",
  "source_tags": "Tagy",
  "source_comma": "oddelené čiarkou",
  "source_select": "vyberte prosím zdroj",
  "source_type": "Typ",
  "source_save": "uložiť",
  "source_cancel": "zrušiť",
  "source_saved": "uložené",
  "no_entries": "žiadny záznam",
  "more": "víac",
  "login": "prihlásiť",
  "login_username": "meno",
  "login_password": "heslo",
  "no_title": "Bez titulku",
  "error": "nastala chyba"
}
